import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"fuel-component mt-1 pa-0 pr-2 pl-3"},[(_vm.isEditChecklist)?_c(VRow,{staticClass:"pa-0"},[_c(VCol,{attrs:{"cols":"12"}},[_c(VForm,{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c(VCombobox,_vm._b({on:{"change":_vm.updateEmailList}},'v-combobox',_vm.propsCombobox,false))],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }